// MainPage.js
import React, { useState } from 'react';
import './dosier_cientifico.css'; // Add custom styles for the main content
import { useTranslation } from 'react-i18next';

const DosierCientifico = () => {
    const { t, i18n } = useTranslation('dosier_cientifico');

    return (
        <main className="main-content">
            {/* Main Section */}
            <section className="dosier">
                <div className="dosier__image">
                    <img src={`${process.env.PUBLIC_URL}/images/Imagen-7-scaled.jpg`} alt="logo" />
                    <div className="dosier__image__text"><span>{t('dosier_tittle')}</span></div>
                </div>
            </section>

            <section className="dosier__info">
                <div className="dosier__info__box">
                    <span>{t('dosier_text_1')}<br></br><br></br>{t('dosier_text_2')}</span>
                    <a href="https://quiropractica-aeq.com/Dossier-Septiembre-2021/ "><br></br>quiropractica-aeq.com</a>
                </div>
            </section>
        </main>
    );
};

export default DosierCientifico;
